var _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCategory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 109,
    rx: 5.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9131,
    y: 26.6523,
    width: 26.087,
    height: 26.087,
    rx: 6,
    fill: "#1D58CA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3044,
    y: 26,
    width: 26.087,
    height: 26.087,
    rx: 6,
    fill: "#49D3FE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6087,
    y: 57.3047,
    width: 26.087,
    height: 26.087,
    rx: 6,
    fill: "#49D3FE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 56.6523,
    width: 26.087,
    height: 26.087,
    rx: 6,
    fill: "#49D3FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCategory);
export default __webpack_public_path__ + "static/media/addCategory.ef6273a30b0369b90a934616d6b71a9c.svg";
export { ForwardRef as ReactComponent };